module.exports = __webpack_public_path__ + "static/media/foot-right-front.c4e7cc54.png";